// Helpers for deciding where a signed-in user belongs.
//
// Everything here reads the /api/auth/user/ payload:
//   admin_permissions - booleans
//   group_permissions - per-group objects whose values are summed integers
//   is_on_prem        - server-wide flag from raptor_global_settings
//   org_sso           - the user's own organization's flag from raptor_securityparams

export const ADMIN_PERMISSION_KEYS = ['root_admin', 'server_admin', 'org_admin', 'group_admin', 'user_admin'];

// True when this deployment routes users to the Wake Portal at all: an on-premises
// install whose organization authenticates through SSO.
export const isWakePortalDeployment = (userInfo) => !!userInfo?.is_on_prem && !!userInfo?.org_sso;

// True when the user should land on the standalone Wake Portal instead of the admin
// console.
//
// Admins are deliberately exempt: both flags are deployment-wide, so without this
// every account in an SSO-enabled org - including the root and organization admins
// who administer the server - would be locked out of the console.
export const isWakeOnlyUser = (userInfo) => {
    if (!isWakePortalDeployment(userInfo)) {
        return false;
    }

    const adminPermissions = userInfo?.admin_permissions;
    if (!adminPermissions || ADMIN_PERMISSION_KEYS.some((key) => adminPermissions[key])) {
        return false;
    }

    return true;
};
